import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, MonitorSmartphoneIcon } from 'lucide-react';
import { bonuses } from '../data/volumes';
export function Bonuses() {
  return <section aria-label="Bonuses" className="border-y border-grape/10 bg-white/70" data-id="element-16" data-mp="avd0wv3lk2dp">
      <div className="mx-auto max-w-5xl px-5 py-6" data-id="element-17" data-mp="fu6baenl7d9n">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-18" data-mp="fsv6cbienzgy">
          🎁 4 Free Professional Bonuses
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-sm font-bold uppercase tracking-wide text-grape" data-id="element-19" data-mp="5w0da84wira2">
          Included With Your Purchase
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-20" data-mp="3o36bwmv8bejy">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative flex gap-4 rounded-2xl border border-grape/20 bg-cream p-5" data-id="element-21" data-mp="3t1hj0pu53ayh" data-mpi={i}>
              <img src={b.cover} alt={`${b.title} bonus cover`} width={1122} height={1402} loading="lazy" decoding="async" sizes="128px" className="h-auto w-24 shrink-0 self-start rounded-md object-contain drop-shadow-[0_10px_18px_rgba(10,10,10,0.35)] sm:w-32" data-id="element-22" data-mp="3dfv836n6zrdg" />
              <div className="flex min-w-0 flex-col" data-id="element-23" data-mp="3n7isinlc085f">
                <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-24" data-mp="2zglqc2jc8p7d">
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-plum px-3 py-1 text-xs font-bold text-white" data-id="element-25" data-mp="2uh97dsvl82a2">
                    <GiftIcon className="h-3.5 w-3.5 text-grape-soft" data-id="element-26" data-mp="38e5ubj8l4zlo" /> Bonus {b.n}
                  </span>
                  <span className="whitespace-nowrap text-sm font-bold" data-id="element-27" data-mp="33jiee8rnddip">
                    <span className="text-plum/40 line-through" data-id="element-28" data-mp="no6p3hixd4mr">{b.price}</span>{' '}
                    <span className="text-grape" data-id="element-29" data-mp="iq56sytbp9cc">FREE</span>
                  </span>
                </div>
                <h3 className="text-base font-black uppercase leading-tight text-plum" data-id="element-30" data-mp="3cielz3kdjuz3">{b.title}</h3>
                <p className="mt-1 text-xs font-semibold leading-snug text-grape-deep" data-id="element-31" data-mp="3hgg5tqpmjybm">{b.subtitle}</p>
                <p className="mt-2 text-sm leading-relaxed text-plum/65" data-id="element-32" data-mp="3lk4gii9jza13">{b.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <p className="mt-8 flex items-center justify-center gap-2 text-center text-sm font-semibold text-plum/60" data-id="element-33" data-mp="2tsoscjsclf8r">
          <MonitorSmartphoneIcon className="h-4 w-4 shrink-0 text-grape" aria-hidden="true" data-id="element-34" data-mp="2xtidj5eeofxy" />
          Access your engineering resources from compatible desktop and mobile devices.
        </p>

        <div className="mt-6 rounded-2xl bg-plum p-4 text-center" data-id="element-35" data-mp="37kd5mqec29rb">
          <p className="text-base font-bold text-white sm:text-lg" data-id="element-36" data-mp="37lo8mnzyfdhd">
            💰 Total Bonus Value: <span className="text-white/50 line-through" data-id="element-37" data-mp="2a2d0sz3ri3rv">$120</span>{' '}
            <span className="text-[15px] text-grape-soft" data-id="element-38" data-mp="2f27q4y7w2lat">
              TODAY FREE WITH THE COMPLETE 5-IN-1 COMBO
            </span>
          </p>
        </div>
      </div>
    </section>;
}